const areas = [
  "Caterham", "Warlingham", "Oxted", "Redhill", "Reigate",
  "Coulsdon", "Purley", "South Croydon", "Kenley", "Whyteleafe",
  "Banstead", "Epsom", "Sutton", "Bromley", "Croydon",
];

export default function AreasCovered() {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span
              className="text-amber-600 text-xs font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Coverage
            </span>
            <h2
              className="text-4xl font-bold text-zinc-900 mt-3 mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Areas We Cover
            </h2>
            <p className="text-zinc-500 text-base leading-relaxed mb-8" style={{ fontFamily: "'Raleway', sans-serif" }}>
              Based in Caterham, Surrey, our installation teams serve homeowners across a wide area of Surrey and South London. Not sure if we cover your area? Give us a call!
            </p>
            <div className="flex flex-wrap gap-3">
              {areas.map((area) => (
                <span
                  key={area}
                  className="bg-white border border-stone-200 text-zinc-700 text-sm px-4 py-2 rounded-full"
                  style={{ fontFamily: "'Raleway', sans-serif" }}
                >
                  {area}
                </span>
              ))}
            </div>
          </div>

          {/* Map Embed */}
          <div className="rounded-lg overflow-hidden h-80">
            <iframe
              title="Ensure Windows Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2490.5!2d-0.0820!3d51.2825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zCaterham%2C+Surrey+CR3+5UG!5e0!3m2!1sen!2suk!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
